import { render, staticRenderFns } from "./DetailInformationDialog.vue?vue&type=template&id=047b84fe&scoped=true"
import script from "./DetailInformationDialog.vue?vue&type=script&lang=js"
export * from "./DetailInformationDialog.vue?vue&type=script&lang=js"
import style0 from "./DetailInformationDialog.vue?vue&type=style&index=0&id=047b84fe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047b84fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('047b84fe')) {
      api.createRecord('047b84fe', component.options)
    } else {
      api.reload('047b84fe', component.options)
    }
    module.hot.accept("./DetailInformationDialog.vue?vue&type=template&id=047b84fe&scoped=true", function () {
      api.rerender('047b84fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinanceVer2/ByClass/TableSearchDialog/DetailInformationDialog.vue"
export default component.exports